import angular from "angular"
import core from "../../core/core.module";

let mod = angular
    .module('finalOrder', [core])
    .component('finalOrder', {
        template: require('./finalOrder.html'),
        controller: [controller],
        bindings: {
            route: '<',
            routeInd: '<',
            passengers: '<',
            allBooking: '<',
            retryBook: '&',
            sendToConfirm: '&',
            cancel: '&',
            edit: '&',
            allIssue: '<'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.typeLetters = $ctrl.route.label.split('');
    };

    $ctrl.$onChanges = function (changes) {
    }

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/finalOrder/finalOrder.js